/** Baunheim の世界の紹介。キャラクター新規作成画面で、世界を選んだときに出す。文面と紋章を持つ */
export default function WorldIntro() {
  return (
    <>
      <img className="world-intro-crest" src="/Baunheim/ui/crest-baunheim.webp" alt="" width={192} height={226} />
      <p className="world-intro-lead">魔法と科学が、同じ空の下でにらみ合う世界。</p>
      <p>魔王が治める領。魔力を禁じ、科学だけで立つ国。魔導師が革命の果てに建てた国。自然とともに生きる島国。騎士の国、医の神を戴く国、海の底の都。</p>
      <p>六つの種族は、三百年前の大災害の傷を抱えたまま、それぞれの答えを生きている。</p>
      <p>魔物が潜むこの世界で、剣を取るか、槌を取るか、人の手を取るか、闇を取るか。何者になるかは、あなたが決める。</p>
      <p className="world-intro-last">十字歴 270 年、9 月 1 日。あなたの物語は、ここから始まる。</p>
    </>
  );
}
